



@if (typdeBtnAction != btnActionEnum.CUSTOM && typdeBtnAction != btnActionEnum.SEARCH) {
  <button id="idBtnAction"  title="{{btnActionInterface.text}}" class="btn-action-page bnt-action-page-all" (click)="onActionFilter($event)" [disabled]="btnDisabled">
    <i class="{{btnActionInterface.icon}} btn-icon"></i>
  </button>
}

@if (typdeBtnAction == btnActionEnum.CUSTOM) {
  <button id="idBtnActionCustom" class="btn-action-page bnt-action-page-all-cutom"  title="{{btnActionInterface.text}}" (click)="onActionFilter($event)" [disabled]="btnDisabled" >
    <i class="{{iconCustom}} btn-icon" ></i>
    <span class="text-cutom">{{btnActionInterface.text}}</span>
  </button>
}

@if (typdeBtnAction == btnActionEnum.SEARCH) {
  <button id="idBtnAction"
    [ngClass]="['bnt-action-page-all',activeBtnSearch ? 'btn-action-page-clicked-export' : 'btn-action-page' ]"
    (click)="onActionFilter($event)" [disabled]="btnDisabled" title="{{btnActionInterface.text}}">
    <i class="{{btnActionInterface.icon}} btn-icon"></i>
  </button>
}
